module.exports = __webpack_public_path__ + "img/mp1.6c443471.png";